import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { EnableLostModeCommand } from '@era/locations-sdk';
import { DeviceStoreActions } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Device } from '@rocksoft/shared';
import { LostModeConfirmationModalComponent } from '../../../components/modals/lost-mode-confirmation-modal/lost-mode-confirmation-modal.component';

@Component({
  selector: 'era-device-details-context-menu-ui',
  templateUrl: './device-details-context-menu.component.html',
  styleUrls: ['./device-details-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, FaIconComponent, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem],
})
export class DeviceDetailsContextMenuComponent {
  readonly device = input<Device>();

  private readonly modalService = inject(NgbModal);
  private readonly store = inject(Store);

  rebootRequest() {
    const udid = this.device()?.udid;
    if (udid) {
      this.store.dispatch(
        DeviceStoreActions.DeviceDetailsContextMenuActions.deviceRestartCommandSent({
          udid: udid,
        })
      );
    }
  }

  openLostModeConfirmationModal() {
    const lostModeModalRef = this.modalService.open(LostModeConfirmationModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });

    void lostModeModalRef.result.then((result) => {
      const udid = this.device()?.udid;
      if (!result || !udid) {
        return;
      }

      if (!result.footnote || result.footnote == null) {
        result.footnote =
          'This iPad has been reported as lost/stolen. Please bring it to an ambassador in the nearest citizenM hotel.';
      }

      const command: EnableLostModeCommand = {
        message: result.message,
        phoneNumber: '',
        footnote: result.footnote,
      };
      this.store.dispatch(
        DeviceStoreActions.DeviceDetailsContextMenuActions.deviceLostModeCommandSent({
          udid: udid,
          enableLostModeCommand: command,
        })
      );
    });
  }

  disableLostModeRequest() {
    const udid = this.device()?.udid;
    if (udid) {
      this.store.dispatch(
        DeviceStoreActions.DeviceDetailsContextMenuActions.deviceDisableLostModeCommandSent({
          udid: udid,
        })
      );
    }
  }
}
